import React from "react";
import { Progress } from "./ui/progress";
import { passwordIssues, passwordScore } from "../lib/format";

export const PasswordStrength = ({ value = "" }) => {
  if (!value) return null;
  const score = passwordScore(value);
  const issues = passwordIssues(value);
  const pct = (score / 5) * 100;
  const label = score <= 2 ? "Weak" : score === 3 ? "Fair" : score === 4 ? "Good" : "Strong";
  const color =
    score <= 2
      ? "bg-destructive"
      : score === 3
      ? "bg-[hsl(var(--warning))]"
      : "bg-[hsl(var(--profit))]";
  return (
    <div className="space-y-1.5" data-testid="password-strength-meter">
      <Progress value={pct} className="h-1.5" indicatorClassName={color} />
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs text-muted-foreground">
          {issues.length ? `Needs: ${issues.join(", ")}` : "Meets all requirements"}
        </p>
        <span className="shrink-0 text-xs font-medium" data-testid="password-strength-label">
          {label}
        </span>
      </div>
    </div>
  );
};
